<template>
    <modal id="sign-in-modal" size="md">
        <template slot="title">Login</template>
        <template slot="body">
            <form action="#" method="post">
                <field-input type="email" placeholder="Email" name="email" v-model="form.email" :autofocues="true" :required="true"></field-input>
                <field-input type="password" name="password" placeholder="Password" v-model="form.password" :required="true"></field-input>
            </form>
            <a href="/password/reset">Forgot your Password?</a>
        </template>
        <template slot="footer">
            <submit-button :form="form" @click="submit()" class="btn-primary" :with-icon="false" processing-text="Signing in...">Sign In</submit-button>
        </template>
    </modal>
</template>
<script>
    export default {

        data() {
            return {
                listenKeys: true,
                form: new Form({
                    email: '',
                    password: '',
                }),
            }
        },

        mounted() {
            window.addEventListener('keyup', (e) => {
                if (e.keyCode == 13 && this.isModalOpen('sign-in-modal') && this.listenKeys) {
                    this.submit();
                }
            })
        },

        methods: {
            submit() {
                this.listenKeys = false;
                this.form.post(`/login`).then(response => {
                    this.closeModal('sign-in-modal')
                    this.refreshPage();
                }).catch(errors => {
                    Alert.error(errors.first())
                    this.listenKeys = true;
                })
            }
        }
    }
</script>